"use client";

import { useEffect, useState } from "react";

import { getCountdownLabel } from "./countdown-utils";

/**
 * Renders the "X weeks and Y days" countdown text. Seeded with a server-computed
 * `initialLabel` (so there is no hydration mismatch), then recomputed from the
 * visitor's own clock on mount so the figure is accurate every day, regardless
 * of when the page was statically generated.
 */
export function BfCountdownLabel({ initialLabel }: { initialLabel: string }) {
  const [label, setLabel] = useState(initialLabel);

  useEffect(() => {
    setLabel(getCountdownLabel(new Date()));
  }, []);

  return <>{label}</>;
}
